import Vue from 'vue';
// Initialize Sentry logger.
// Docs:
//  - https://docs.sentry.io/platforms/javascript/vue/
//  - https://docs.sentry.io/platforms/node/sourcemaps/
//  - https://docs.sentry.io/platforms/node/typescript/
//  - https://docs.sentry.io/platforms/node/pluggable-integrations/
//  - https://docs.sentry.io/performance-monitoring/getting-started/
import * as SentryIntegrations from '@sentry/integrations';
import { Integration } from '@sentry/types';
import { Integrations as ApmIntegrations } from '@sentry/apm';

const _integrations: Array<Integration | ApmIntegrations.Tracing> = [
  new SentryIntegrations.CaptureConsole({ levels: ['warn', 'error', 'debug', 'assert'] }),
  new SentryIntegrations.ExtraErrorData(),
  new SentryIntegrations.RewriteFrames({ root: '/opt/polaris/www' }),
  new SentryIntegrations.Vue({ Vue, attachProps: true, logErrors: true }),
];

import { isBrowser } from 'browser-or-node';
if (isBrowser) {
  var _Sentry = require('@sentry/browser');
  // The Tracing integration is specific to @sentry/browser and does not work with @sentry/node.
  _integrations.push(new ApmIntegrations.Tracing());
} else {
  var _Sentry = require('@sentry/node');
  _integrations.push(_Sentry.Integrations.Modules(), _Sentry.Integrations.Transaction());
}

export const integrations = _integrations;
export const Sentry = _Sentry;
